export default __webpack_public_path__ + "static/home-school-9aecbcc745a907706b053cd62e344798.jpg";